import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { GECKO_CONSTS } from '../../../ui/constants';
import GeckoLocation from '../../../services/gecko-location';
import GeckoRequest from '../../../services/gecko-request';
import { GeckoCardForm } from '../../../ui/components';

const fields = [
  {
    key: 'chosen_module',
    label: 'Choose Module Type',
    required: true,
    options: [
      { label: 'Contact', value: 'Contact' },
      { label: 'Lead', value: 'Lead' },
    ],
    width: 'col-xs-12',
    type: GECKO_CONSTS.FIELD_TYPE_SELECT,
  },
];

const validateIntegrationPayload = (payload) =>
  payload.account_id && payload.configuration.code;

const failedIntegration = (
  <GeckoCardForm name="Integration failed. Please try again. If the issues persists please contact Support" />
);

export function SalesForceConfirmationDialog({ code }) {
  const currentUser = useSelector((state) => state.appState.loggedInUser);
  const [module, setModule] = useState('Lead');

  const newSalesforceIntegration = {
    account_id: currentUser.account_id,
    configuration: { code, module },
    type: 'salesforce',
  };

  const onUserInput = (_, chosenValue) => setModule(chosenValue);

  const handleSubmit = (_) =>
    GeckoRequest.post('/integration/', newSalesforceIntegration)
      .then((_) => GeckoLocation.goTo(`/settings/integration/salesforce`))
      .catch((_) =>
        GeckoLocation.goTo(`/settings/integrations/?&setup=failed`)
      );

  const footerButtons = [
    {
      name: 'Done',
      type: 'success',
      icon: 'far fa-check',
      handler: handleSubmit,
      disabledWhen: (_) => module === null || module === undefined,
    },
  ];

  const selectModuleModal = (_) => (
    <GeckoCardForm
      name="Please select the Salesforce module:"
      fields={fields}
      values={{ chosen_module: module }}
      footerBtns={footerButtons}
      handler={onUserInput}
      key={module}
    />
  );

  return (
    <div className="content-margin">
      {' '}
      {validateIntegrationPayload(newSalesforceIntegration)
        ? selectModuleModal()
        : failedIntegration}{' '}
    </div>
  );
}
